import React, {useEffect, useState} from 'react';
import { renderDropdown, renderDropdownReadOnly} from "./DropdownFunctions";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import PropTypes from "prop-types";
import {Globals} from "root/DataFunctions/BaseDataFns";
import {genericListboxFetch} from "root/ReactHookForm/ui/DropdownDataProviders";
import {ChildRoles} from "root/DataFunctions/Constants";

const ReactHookFormDropdownChildSiblings= (props) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        const url = Globals.APIFolder + '/users/current/contacts?user_role=' + ChildRoles.CONTRIBUTOR + '&direction=send' ;

        genericListboxFetch({ url: url, keyFieldName:'user_id', labelFieldName:'name', additionalFields:['idusers']}).then((response) =>
        {
            setData ( { loading: false, items: response }) ;
        }) ;

    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props.value, props.onChange, data.items, { ...props.options, ... {isSearchable: true}}) : renderDropdown(props.value, props.onChange, data.items, { ...props.options, ... {isSearchable: true}})
    )
}

export default ReactHookFormDropdownChildSiblings;

ReactHookFormDropdownChildSiblings.defaultProps =
{
    defaultClassName: ''
}

ReactHookFormDropdownChildSiblings.propTypes = {
    onChange: PropTypes.func.isRequired
};
